export function fetchRenewOptions(serviceid) {
  return fetch(
    process.env.REACT_APP_BASE_API + 'order/apis/getListRenew.php?serviceid=' + serviceid
  ).then((response) => {
    const data = response.json();
    return data.then((result) => {
      if (result.status === 'error') {
        const error = new Error(result.message || 'Failed to fetch renew options');
        throw error;
      }
      return result;
    });
  })
}

export function fetchAllRenewServices() {
  return fetch(
    process.env.REACT_APP_BASE_API + 'order/apis/getListRenew.php'
  ).then((response) => response.json())
}

// Helper function to calculate remaining days until next due date
export function calculateRemainingDays(nextDueDate) {
  if (!nextDueDate || nextDueDate === '0000-00-00' || nextDueDate === '0000-00-00 00:00:00') {
    return 0;
  }
  
  const today = new Date();
  const dueDate = new Date(nextDueDate);
  
  // Check if date is valid
  if (isNaN(dueDate.getTime())) {
    console.warn('Invalid date format:', nextDueDate);
    return 0;
  }
  
  const diffTime = dueDate - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return Math.max(0, diffDays);
}

// Helper function to format currency
export function formatIDR(amount) {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

// Helper function to get billing cycle label
export function getBillingCycleLabel(billingcycle) {
  const cycleMap = {
    'monthly': '1 Bulan',
    'quarterly': '3 Bulan',
    'semiannually': '6 Bulan',
    'semi-annually': '6 Bulan',
    'annually': '1 Tahun',
    'biennially': '2 Tahun',
    'triennially': '3 Tahun'
  };
  return cycleMap[billingcycle] || billingcycle;
}

// Helper function to check if service is renewable
export function isServiceRenewable(service) {
  return service.can_renew === true;
}

// Helper function to check if domain is renewable
export function isDomainRenewable(domain) {
  return domain.can_renew === true;
}

// Helper function to safely format date
export function formatDate(dateString) {
  if (!dateString || dateString === '0000-00-00' || dateString === '0000-00-00 00:00:00') {
    return 'Tidak tersedia';
  }
  
  const date = new Date(dateString);
  
  // Check if date is valid
  if (isNaN(date.getTime())) {
    console.warn('Invalid date format:', dateString);
    return 'Format tanggal salah';
  }
  
  return date.toLocaleDateString('id-ID');
}
